import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import WebHttpClient from '~src/httpClient/WebHttpClient';

import { IAdminProfile, IAdminProfileDetails } from '../models/IAdminProfile';
import { IAdminProfileTemplate } from '../models/IAdminProfileTemplate';
import { CreateAdminProfileRequest, ICreateAdminProfileParams, ICreateAdminProfileResult } from '../requests/CreateAdminProfileRequest';
import { DeleteAdminProfilesRequest, IDeleteAdminProfilesResult } from '../requests/DeleteAdminProfilesRequest';
import { GetAdminProfileDetailsRequest } from '../requests/GetAdminProfileDetailsRequest';
import { GetAdminProfileTemplateRequest, IGetAdminProfileTemplateResult } from '../requests/GetAdminProfileTemplateRequest';
import { GetServerAdminProfilesRequest, IGetServerAdminProfilesResult } from '../requests/GetServerAdminProfilesRequest';
import { RemoveUsersFromProfileRequest } from '../requests/RemoveUsersFromProfileRequest';
import { ISetUserAdminProfileBySitesParams, ISetUserAdminProfileBySitesResult, SetUserAdminProfileBySitesRequest } from '../requests/SetUserAdminProfileBySitesRequest';
import { IUpdateAdminProfileParams, IUpdateAdminProfileResult, UpdateAdminProfileRequest } from '../requests/UpdateAdminProfileRequest';
import { IUpdateAdminProfileSitesParams, IUpdateAdminProfileSitesResult, UpdateAdminProfileSitesRequest } from '../requests/UpdateAdminProfileSitesRequest';


export namespace AdminProfilesService {
    export function getAdminProfilesForServer(): Promise<IAdminProfile[]> {
        const result = WebHttpClient.sendRequest(new GetServerAdminProfilesRequest({}));
        return result.then((result: IGetServerAdminProfilesResult) => {
            return result.adminProfiles;
        });
    }

    export function getAdminProfileDetails(luid: string): Promise<IAdminProfileDetails> {
        const result = WebHttpClient.sendRequest(new GetAdminProfileDetailsRequest({ luid }));
        return result.then((result: IAdminProfileDetails) => {
            return result;
        });
    }

    export function getAdminProfileTemplate(): Promise<IAdminProfileTemplate> {
        const result = WebHttpClient.sendRequest(new GetAdminProfileTemplateRequest({}));
        return result.then((result: IGetAdminProfileTemplateResult) => {
            return {
                permissions: result.permissions
            };
        });
    }

    export function createAdminProfile(params: ICreateAdminProfileParams): Promise<ICreateAdminProfileResult> {
        return WebHttpClient.sendRequest(new CreateAdminProfileRequest(params))
            .then((result: ICreateAdminProfileResult) => {
                return result;
            }, (reason) => {
                if (typeof reason === 'number') {
                    return { luid: undefined, errors: [{ code: reason }] } as ICreateAdminProfileResult;
                }
                return Promise.reject(reason);
            });
    }

    export function updateAdminProfile(params: IUpdateAdminProfileParams): Promise<IUpdateAdminProfileResult> {
        return WebHttpClient.sendRequest(new UpdateAdminProfileRequest(params))
            .then((result: IUpdateAdminProfileResult) => {
                return result;
            }, (reason) => {
                if (typeof reason === 'number') {
                    return { luid: undefined, errors: [{ code: reason }] } as IUpdateAdminProfileResult;
                }
                return Promise.reject(reason);
            });
    }

    export function updateAdminProfileSites(params: IUpdateAdminProfileSitesParams): Promise<IUpdateAdminProfileSitesResult> {
        return WebHttpClient.sendRequest(new UpdateAdminProfileSitesRequest(params));
    }

    export function removeUsersFromProfile(userLuids: string[], adminProfileLuid?: string): Promise<IResult> {
        return WebHttpClient.sendRequest(new RemoveUsersFromProfileRequest({ userLuids, adminProfileLuid }));
    }

    export function setUserAdminProfileBySites(params: ISetUserAdminProfileBySitesParams): Promise<ISetUserAdminProfileBySitesResult> {
        return WebHttpClient.sendRequest(new SetUserAdminProfileBySitesRequest(params));
    }

    export function deleteAdminProfile(profileLuid: string): Promise<IDeleteAdminProfilesResult> {
        return WebHttpClient.sendRequest(new DeleteAdminProfilesRequest({ profileLuids: [profileLuid] }))
            .then((result: IDeleteAdminProfilesResult) => {
                return result;
            }, (reason) => {
                if (typeof reason === 'number') {
                    return { errors: [{ code: reason }] } as IDeleteAdminProfilesResult;
                }
                return Promise.reject(reason);
            });
    }
}
